import React from 'react'
import { Form } from 'react-bootstrap'
import constants from '../../../../config/constants'
import { toast } from 'react-toastify'
import { uploadFile } from '../../../../services/genericService'
import { friendlyMessageFor } from '../../../../utility/errorHelper'

type Props = {
  images: string[]
  onImageUpload: any
  handleError: any
  handleTouch: any
}

const ImageUpload = ({
  onImageUpload,
  images,
  handleError,
  handleTouch
}: Props) => {
  return (
    <>
      <div className="file-upload-wrapper" data-testid="image-upload">
        <Form.File>
          <Form.File.Input
            id="listing-image"
            name="images"
            accept="image/*"
            isInvalid={images.length === 0 && handleTouch.images}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              let listingImage = e.target.files![0]
              toast.info(constants.alertMessage.uploadingImage, {
                autoClose: false
              })
              if (e.target.files) {
                uploadFile(listingImage, 'listings')
                  .then(url => {
                    onImageUpload(url!)
                    toast.dismiss()
                  })
                  .catch(error => {
                    console.log(error)
                    toast.warn(friendlyMessageFor(error.code))
                  })
              } else {
                toast.info(constants.alertError.listingForm.imageNotFound, {
                  autoClose: false
                })
              }
            }}
          />
        </Form.File>

        {images.length === 0 && (
          <div className="invalid-feedback d-block" data-testid="invalid">
            {handleError.images}
          </div>
        )}
      </div>
    </>
  )
}

export default ImageUpload
